import SaveConfirmationModal from './SaveConfirmationModal';

export default SaveConfirmationModal;
